<template>
    <el-row style="margin-bottom: 20px;">
        <el-col :span="label_span">
            <span v-if="field_mark" :class="'field-mark ' + field_mark"></span>
            <slot name="label"></slot>
        </el-col>
        <el-col :span="field_span" :class="{'float-right': $langConfig.dir == 'rtl'}">
            <slot name="field"></slot>
        </el-col>
        <el-col :span="24" class="error-field-validate-message" v-if="field_validate_message || field_is_textarea">
            <!--<div v-if="field_is_textarea" :style="'margin-top:' + (field_textarea_rows * textarea_error_top_margin) + 'px'">
            </div>-->
            {{field_validate_message}}
        </el-col>
    </el-row>
</template>

<script>
export default {
  props: {
    field_textarea_rows: {
      required: false,
      default: 1
    },
    field_is_textarea: {
      required: false,
      default: false
    },
    field_validate_message: {
      required: false
    },
    field_mark: {
      required: true
    },
    label_span: {
      required: false,
      default: 4
    },
    field_span: {
      required: false,
      default: 4
    },
    textarea_error_top_margin: {
      required: false,
      default: 20
    }
  }
}
</script>